import _ from 'lodash';
import { TSelectValue } from '@models/common';

const DEFAULT_MAX_YEARS = 7;

// Shape tối thiểu cần cho component — mỗi màn có thể truyền thẳng session item riêng
// (TInventorySessionItem, TPeriodOption, ...) miễn có field `inventoryYearMonth`.
type TSessionYearMonthItem = {
  inventoryYearMonth: string;
};

const parseYearMonth = (value?: string) => {
  if (!value || value.length < 6) {
    return { year: undefined, month: undefined } as {
      year?: string;
      month?: string;
    };
  }
  return { year: value.slice(0, 4), month: value.slice(4, 6) };
};

const buildYearOptions = (
  sessions: TSessionYearMonthItem[],
  maxYears: number = DEFAULT_MAX_YEARS
): TSelectValue[] => {
  const years = _.chain(sessions)
    .map((item) => item.inventoryYearMonth?.slice(0, 4))
    .compact()
    .uniq()
    .orderBy((year) => year, 'desc')
    .take(maxYears)
    .value();

  return years.map((year) => ({ value: year, label: `${year}年` }));
};

const buildMonthOptions = (
  sessions: TSessionYearMonthItem[],
  year?: string
): TSelectValue[] => {
  if (!year) {
    return [];
  }

  const months = _.chain(sessions)
    .filter((item) => item.inventoryYearMonth?.slice(0, 4) === year)
    .map((item) => item.inventoryYearMonth?.slice(4, 6))
    .compact()
    .uniq()
    .orderBy((month) => month, 'desc')
    .value();

  return months.map((month) => ({ value: month, label: `${month}月` }));
};

// Khi đổi năm, giữ nguyên tháng cũ nếu năm mới cũng có kỳ đó, ngược lại chọn tháng mới nhất.
const resolveYearMonthChange = (
  sessions: TSessionYearMonthItem[],
  nextYear: string,
  prevMonth?: string
): string => {
  const monthOptions = buildMonthOptions(sessions, nextYear);
  const keepMonth = monthOptions.some((option) => option.value === prevMonth);
  const month = keepMonth ? prevMonth! : monthOptions[0]?.value;
  return month ? `${nextYear}${month}` : '';
};

export {
  DEFAULT_MAX_YEARS,
  parseYearMonth,
  buildYearOptions,
  buildMonthOptions,
  resolveYearMonthChange,
};
export type { TSessionYearMonthItem };
